import '../../../../../styles/user-form.scss';
import { IntlType } from '../../../../../utils/typing';
import { Formik } from '../../../hooks/useForm';
import { FormSelections } from '../hooks/useFormSelections';
import SiteSelector from './SiteSelector';
import UserGroupSelect from './UserGroupSelect';

interface Props {
  intl: IntlType;
  formik: Formik;
  formSelections: FormSelections;
}

const UserForm = (props: Props): JSX.Element => {
  return (
    <form data-testid="user-form" onSubmit={(e) => e.preventDefault()}>
      <div className="form-row half">
        <div className="form-group">
          <UserGroupSelect {...props} />
        </div>
        <div className="form-group">
          <SiteSelector {...props} />
        </div>
      </div>
    </form>
  );
};

export default UserForm;
